interface IMessage {
  id: string;
  role: "user" | "model";
  content: string;
  createdAt: Date;
}

export default class Message {
  private _id: string;
  private _role: "user" | "model" = "user";
  private _content: string;
  private _createdAt: Date;

  constructor(message: IMessage) {
    this._id = message.id;
    this._role = message.role;
    this._content = message.content;
    this._createdAt = message.createdAt;
  }

  get id() {
    return this._id;
  }

  get role() {
    return this._role;
  }

  get content() {
    return this._content;
  }

  get createdAt() {
    return this._createdAt;
  }

  updateContent(content: string) {
    if (this._content.includes(content)) return;
    
    this._content += content;
  }
}

/**
 * mkdir my-react-app
cd my-react-app
 */